<mat-chip-listbox #chipList class="custom_chip_box">
  <mat-chip *ngFor="let value of values" class="custom-chip" [selectable]="selectable" [removable]="removable" (removed)="remove(value)"
    [class.disable]="!removable" [title]="value.description ? value.description : value.name">
    <span class="custom_icon">{{value.name}}</span>
    <mat-icon matChipRemove *ngIf="removable" class="pl-1 pr-2"><span class="custom_icon">cancel</span></mat-icon>
  </mat-chip>
  <input #inputText matInput [formControl]="textcontrol" class="type-box-input" [matAutocomplete]="tech"
    [matChipInputFor]="chipList" [placeholder]="removable && !limitedSelection ?placehold:''"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
    (matChipInputTokenEnd)="add($event)" (input)="selectionChange($event.target.value)" (focus)="selectionChange('')"
    [disabled]="!removable || limitedSelection">
</mat-chip-listbox>

<mat-autocomplete #tech="matAutocomplete" (optionSelected)="selected($event,textcontrol.value)">
  <mat-option *ngFor="let value of filteredValues" [value]="value">
    {{value.name}} <span *ngIf="value.employeeId !=null"> ({{value.employeeId}}) </span>
  </mat-option>
</mat-autocomplete>